import { ModuleDropdown } from '@ghq-abi/design-system';
import { useTranslate } from '@tolgee/react';

import { useModuleItems } from './hooks/useModuleItems';

export function ModulesDropdown() {
  const { t } = useTranslate();
  const { items } = useModuleItems();

  return <ModuleDropdown title={t('modules.quick_access')} items={items} />;
}
